import { Injectable } from "@angular/core";
import { FieldKey, FORM_VALIDATION_MESSAGES } from "../../constants/form-validation-messages.constants";
import { AbstractControl } from "@angular/forms";
import { ValidatorKey } from "../../constants/form-validation-keys.constants";

@Injectable({
    providedIn: "root",
})
export class FormValidationService {
    constructor() {}

    public getHint(field: keyof typeof FORM_VALIDATION_MESSAGES): string {
        return FORM_VALIDATION_MESSAGES[field]?.hint ?? "";
    }

    public getFirstError(
        field: FieldKey,
        control: AbstractControl | null,
        defaultMessage = "Invalid value",
    ): string | null {
        if (!control?.errors || !control.touched) {
            return null;
        }

        const firstErrorKey = Object.keys(control.errors)[0] as ValidatorKey;

        return FORM_VALIDATION_MESSAGES[field]?.errors?.[firstErrorKey] ?? defaultMessage;
    }
}
